import {
  useState,
  useEffect,
  useMemo,
  useCallback,
  Fragment,
  useContext,
} from "react";
import "./Scss/CaseStyles.scss?v=1.1.4";
import Swal from "sweetalert2";
import { NavLink } from "react-router-dom";

// MUI
import {
  Grid,
  TextField,
  Autocomplete,
  CircularProgress,
  Button,
  Fade,
  Alert,
  Tooltip,
  IconButton,
} from "@mui/material";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  ArrowForwardIos,
  CleaningServices,
  CreateNewFolder,
  Info,
  MoreVert,
  Search,
} from "@mui/icons-material";

// Componentes propios
import Table from "../Components/Common/Table/Table";
import LoadingPage from "../Components/Common/Loading/LoadingPage";
import {
  CommonSubHeader,
  getInfoMessageNoResultsSearch,
  formatDate,
  dateFormat,
  formatToTenDigits,
  normalizeText,
} from "../Components/helpers/Helpers";

// Paginación
import ReactPaginate from "react-paginate";
import dayjs from "dayjs";
import {
  RenderCell,
  RenderTrialDate,
  RenderVencimiento,
} from "../Components/Common/Table/RenderCell";
import { CustomButtonPlusIcon } from "../Components/Common/Design/CustomButtonPlusIcon";
import api from "../api/axios";
import TableActions from "../Components/Common/Table/TableActions";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { PermissionContext } from "../Components/Context/Context";
import Unauthorized from "../Components/Common/Design/Unauthorized";

// ---------- COMPONENTE PRINCIPAL ----------
const Expedientes = ({
  flagToShow = true,
  userCase = 0,
  clientCase = 0,
  handleCasesTransfer = () => {},
  setCaseControlNumber,
  transferClient,
  caseCreated,
  clientCreated,
  currentClientTransfer,
}) => {
  const { can } = useContext(PermissionContext);
  const hasPermission = can("cases", "view");

  // ---------- ESTADOS ----------
  const [data, setData] = useState({
    cases: [],
    totalPagesNumber: 0,
    pageCount: 0,
  });
  const [queryCase, setQueryCase] = useState("");
  const [queryClientName, setQueryClientName] = useState("");
  const [queryClientSurname, setQueryClientSurname] = useState("");

  const initialFilters = {
    caseFilter: "",
    clientFilterName: "",
    clientFilterSurname: "",
    nombre_completo_status_task: "Seleccionar",
    case_type: null,
    association: null,
    lawyer: null,
    peritaje: null,
    provincia: null,
    status: null,
    status_name: "",
    company_id: null,
  };

  const [filters, setFilters] = useState(initialFilters);

  const [pagination, setPagination] = useState({
    objPerPage: 10,
    pagePressed: 1,
  });
  const [flag, setFlag] = useState(false);
  const [dataNoResults, setDataNoResults] = useState(false);
  const [loading, setLoading] = useState({
    cases: false,
    types: false,
    provinces: false,
    case_status: false,
    associations: false,
    companies: false,
    peritaje: false,
    apud_acta: false,
    expiration: false,
    lawyers: false,
  });
  const [options, setOptions] = useState({
    cases: [],
    types: [],
    provinces: [],
    case_status: [],
    associations: [],
    companies: [],
    peritaje: [],
    apud_acta: [],
    expiration: [],
    lawyers: [],
  });
  const [search, setSearch] = useState(false);
  const [dateEndFrom, setDateEndFrom] = useState(null);
  const [dateEndTo, setDateEndTo] = useState(null);

  // ---------- UTILIDADES ----------

  const renderCellWithDefault = (
    value,
    defaultValue = "Sin asignar",
    link = false,
    dateFlag,
  ) => (
    <div className="spanClassForTables centerContent">
      {link ? (
        <NavLink to={`/expedientes/ver?id=${value}`} className="buttonNavLink">
          <Button
            color="info"
            size="small"
            sx={{ fontSize: "12px", height: "28px" }}
            variant="outlined">
            {value}
          </Button>
        </NavLink>
      ) : dateFlag ? (
        dateFormat(value)
      ) : (
        value || defaultValue
      )}
    </div>
  );

  // ---------- FETCH DE DATOS ----------
  const getDataExpedientes = useCallback(async () => {
    setFlag(true);

    // console.log(filters);

    try {
      const response = await api.post(
        process.env.REACT_APP_API_URL + `/cases`,
        {
          page: pagination.pagePressed,
          objPerPage: pagination.objPerPage,
          case_id: filters.caseFilter,
          company_id: filters.company_id
            ? filters.company_id
            : clientCase
              ? clientCase?.company_id
              : currentClientTransfer
                ? currentClientTransfer?.company?.id
                : null,
          case_type: filters.case_type,
          asociation: filters.association,
          province_name: filters.provincia,
          association: filters.association,
          status_task: filters.status,
          status_name: filters.status_name,
          peritaje: filters.peritaje,
          apud_acta: filters.apud_acta,
          expiration: filters.expiration,
          client_id: clientCase?.id || null,
          client_name:
            clientCase?.name ||
            currentClientTransfer?.name ||
            filters.clientFilterName,
          client_surname:
            clientCase?.surname ||
            currentClientTransfer?.surname ||
            filters.clientFilterSurname,
          user_id: Number(userCase) || filters.lawyer,
          date_from_range: dateEndFrom ? formatDate(dateEndFrom)[0] : "",
          date_to_range: dateEndTo ? formatDate(dateEndTo)[0] : "",
        },
      );

      // console.log(transferClient, "transferClient");
      // console.log(clientCase, "clientCase");
      console.log(response, "clientCase");

      if (response?.data?.cases) {
        const {
          cases,
          companyList,
          lawyersListNames,
          provinceList,
          associationList,
          typesList,
          casesByStatusList,
        } = response.data;

        if (userCase || clientCase) {
          setCaseControlNumber(cases?.total);
        }

        setDataNoResults(cases?.data?.length === 0);

        const peritajeList = [
          { id: -1, peritaje: "Seleccionar" },
          { id: 0, peritaje: "Sin Peritaje" },
          { id: 1, peritaje: "Con Peritaje" },
        ];

        const apudActaList = [
          { id: -1, apud_acta: "Seleccionar" },
          { id: 0, apud_acta: "Sin Apud acta" },
          { id: 1, apud_acta: "Con Apud acta" },
        ];

        const expirationList = [
          { id: -1, expiration: "Seleccionar" },
          { id: 0, expiration: "Sin Vencimiento" },
          { id: 1, expiration: "Con Vencimiento" },
        ];

        // if (dateEndFrom || dateEndTo) {
        cases?.data?.map((item) => {
          let trial_date_time = null;

          const isJuicio =
            normalizeText(item?.cases_flow_relation?.status_name) === "juicio";

          if (item?.trial_date) {
            item.trial_date_time = {
              date_end: item.trial_date,
              source: "trial_date",
            };
          } else if (isJuicio && item?.last_task?.date_end) {
            item.trial_date_time = {
              ...item.last_task,
              source: "task_date",
            };
          }
        });
        //     .filter(Boolean) // elimina nulls
        //     .sort((a, b) => {
        //       const dateA = new Date(a.trial_date_time.date_end);
        //       const dateB = new Date(b.trial_date_time.date_end);

        //       return dateA - dateB; // más próximos primero
        //     });
        // }

        setData({
          cases: cases.data,
          totalPagesNumber: cases.total,
          pageCount: cases.last_page,
        });

        const trimmedCasesByStatusList = casesByStatusList.map((item) => ({
          ...item,
          status_name: item.status_name
            ? item.status_name.trim()
            : item.status_name,
        }));

        const uniqueCases = [
          ...new Map(
            casesByStatusList.map((item) => [
              `${item.status_name.trim()}-${item.status}`, // clave compuesta
              item,
            ]),
          ).values(),
        ];

        // console.log(uniqueCases);

        setOptions({
          associations: [
            { asoc_name: "Seleccionar", id: 0 },
            ...associationList,
          ],
          lawyers: [
            { name: "Seleccionar", surname: " ", id: 0 },
            ...lawyersListNames,
          ],
          provinces: [
            { provincia: "Seleccionar", id_provincia: 0 },
            ...provinceList,
          ],
          types: [{ case_type: "Seleccionar", id: 0 }, ...typesList],
          case_status: [
            {
              nombre_completo_status_task: "Seleccionar",
              status_name: "",
              status: 0,
            },
            ...uniqueCases,
          ],
          companies: [{ company_name: "Seleccionar", id: 0 }, ...companyList],
          peritaje: peritajeList,
          apud_acta: apudActaList,
          expiration: expirationList,
        });
      }
      setFlag(false);
    } catch (error) {
      console.error("Error en la respuesta del servidor:", error);
    } finally {
      setFlag(false);
      setLoading((prev) => ({ ...prev, companies: false }));
    }
  }, [
    pagination,
    filters,
    clientCase,
    currentClientTransfer,
    userCase,
    dateEndFrom,
    dateEndTo,
  ]);

  // ---- Añadir después de los useState principales ----
  const filterDataByCompany = useCallback(
    async (company_id, flagFromCompanyInput = false) => {
      if (!company_id) return;

      try {
        const response = await api.post(
          `${process.env.REACT_APP_API_URL}/users/searchdatabycompany`,
          { company: company_id },
        );

        if (response?.data) {
          const { cases_types, associations, lawyers } = response.data;

          // Actualizamos los valores dependientes
          setOptions((prevData) => ({
            ...prevData,
            associations: [
              { asoc_name: "Seleccionar", id: 0 },
              ...associations,
            ],
            types: [{ case_type: "Seleccionar", id: null }, ...cases_types],
            lawyers: [{ name: "Seleccionar", surname: " ", id: 0 }, ...lawyers],
          }));

          // Si proviene del cambio directo en el input de empresa, reiniciamos los filtros dependientes
          if (flagFromCompanyInput) {
            setFilters((prev) => ({
              ...prev,
              association: null,
              case_type: null,
              lawyer: null,
            }));
          }
        }
      } catch (error) {
        console.error("Error al filtrar por empresa:", error);
      }
    },
    [],
  );

  const renderActions = (case_id, relation = false, row = false) => (
    <div
      className="spanClassForTables centerContent"
      style={{
        display: "flex",
        gap: "8px",
        alignItems: "center",
        justifyContent: "center",
      }}>
      {!transferClient ? (
        <TableActions
          rute={"expedientes"}
          value={case_id}
          showView
          module="cases"
        />
      ) : null}

      {transferClient ? (
        <Button
          size="small"
          sx={{ fontSize: "12px", height: "28px" }}
          variant="outlined"
          color="secondary"
          onClick={() => handleCasesTransfer(row)}>
          Transferir
        </Button>
      ) : null}
    </div>
  );

  const handleFilterStates = () => {
    setFilters(initialFilters);
    setDateEndFrom(null);
    setDateEndTo(null);
    setQueryCase(""); // limpia el TextField
    setQueryClientName(""); // limpia el TextField
    setQueryClientSurname(""); // limpia el TextField
    setSearch(!search); // refresca la tabla
  };

  const handlePageClick = (event) => {
    setPagination((prev) => ({ ...prev, pagePressed: event.selected + 1 }));
  };

  const handleAutocompleteOpen = useCallback((field) => {
    setLoading((prev) => ({ ...prev, [field]: true }));
  }, []);

  // ---------- CONFIGURACIÓN DE AUTOCOMPLETE ----------
  const autocompleteConfigs = [
    {
      label: "Empresa",
      key: "companies",
      options: options.companies,
      loading: loading.companies,
      setFilter: (value) => {
        const companyId = value?.id || null;
        setFilters((prev) => ({
          ...prev,
          company_id: companyId,
          association: null,
          case_type: null,
          lawyer: null,
        }));
        // Si se elige una empresa válida, cargamos los datos relacionados
        if (companyId) {
          filterDataByCompany(companyId, true);
        }
      },
      handleOpen: () => handleAutocompleteOpen("companies"),
      handleClose: () => setLoading((prev) => ({ ...prev, companies: false })),
      getOptionLabel: (option) => option.company_name,
      getValue: (filters, options) =>
        options.find((opt) => opt.id === filters.company_id) || null,
    },
    {
      label: "Asociacion",
      key: "associations",
      options: options.associations,
      loading: loading.associations,
      setFilter: (value) =>
        setFilters((prev) => ({ ...prev, association: value?.id || null })),
      handleOpen: () => handleAutocompleteOpen("associations"),
      handleClose: () =>
        setLoading((prev) => ({ ...prev, associations: false })),
      getOptionLabel: (option) => option.asoc_name,
      getValue: (filters, options) =>
        options.find((opt) => opt.id === filters.association) || null,
      disabled: filters?.company_id ? false : true,
      helperText: true,
    },
    {
      label: "Abogado",
      key: "lawyers",
      options: options.lawyers,
      loading: loading.lawyers,
      setFilter: (value) =>
        setFilters((prev) => ({ ...prev, lawyer: value?.id || null })),
      handleOpen: () => handleAutocompleteOpen("lawyers"),
      handleClose: () => setLoading((prev) => ({ ...prev, lawyers: false })),
      getOptionLabel: (option) => option.name + " " + option.surname,
      getValue: (filters, options) =>
        options.find((opt) => opt.id === filters.lawyer) || null,
      disabled: filters?.company_id ? false : true,
      helperText: true,
    },
    {
      label: "Tipo de proceso",
      key: "types",
      options: options.types,
      loading: loading.types,
      setFilter: (value) =>
        setFilters((prev) => ({ ...prev, case_type: value?.id || null })),
      handleOpen: () => handleAutocompleteOpen("types"),
      handleClose: () => setLoading((prev) => ({ ...prev, types: false })),
      getOptionLabel: (option) => option.case_type,
      getValue: (filters, options) =>
        options.find((opt) => opt.id === filters.case_type) || null,
      disabled: filters?.company_id ? false : true,
      helperText: true,
    },
    {
      label: "Peritaje",
      key: "peritaje",
      options: options.peritaje,
      loading: loading.peritaje,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          peritaje: value?.id !== -1 ? value.id : -1,
        })),
      handleOpen: () => handleAutocompleteOpen("peritaje"),
      handleClose: () => setLoading((prev) => ({ ...prev, peritaje: false })),
      getOptionLabel: (option) => option.peritaje,
      getValue: (filters, options) =>
        options.find((opt) => opt.id === filters.peritaje) || null,
    },
    {
      label: "Apud Acta",
      key: "apud_acta",
      options: options.apud_acta,
      loading: loading.apud_acta,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          apud_acta: value?.id !== -1 ? value.id : -1,
        })),
      handleOpen: () => handleAutocompleteOpen("apud_acta"),
      handleClose: () => setLoading((prev) => ({ ...prev, apud_acta: false })),
      getOptionLabel: (option) => option.apud_acta,
      getValue: (filters, options) =>
        options.find((opt) => opt.id === filters.apud_acta) || null,
    },
    {
      label: "Vencimiento",
      key: "expiration",
      options: options.expiration,
      loading: loading.expiration,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          expiration: value?.id !== -1 ? value.id : -1,
        })),
      handleOpen: () => handleAutocompleteOpen("expiration"),
      handleClose: () => setLoading((prev) => ({ ...prev, expiration: false })),
      getOptionLabel: (option) => option.expiration,
      getValue: (filters, options) =>
        options.find((opt) => opt.id === filters.expiration) || null,
    },
    {
      label: "Provincia",
      key: "province",
      options: options.provinces,
      loading: loading.provinces,
      setFilter: (value) =>
        setFilters((prev) => ({
          ...prev,
          provincia: value?.provincia || null,
        })),
      handleOpen: () => handleAutocompleteOpen("provinces"),
      handleClose: () => setLoading((prev) => ({ ...prev, provinces: false })),
      getOptionLabel: (option) => option.provincia,
      getValue: (filters, options) =>
        options.find((opt) => opt.provincia === filters.provincia) || null,
    },
    {
      label: "Estado",
      key: "case_status",
      options: options.case_status,
      loading: loading.case_status,
      setFilter: (value) => {
        // console.log(value);

        setFilters((prev) => ({
          ...prev,
          status: value ? value.status : null,
          status_name: value
            ? value.status_name
              ? value.status_name.trim()
              : ""
            : null,
          nombre_completo_status_task: value
            ? value.nombre_completo_status_task
            : null,
        }));
      },
      handleOpen: () => handleAutocompleteOpen("case_status"),
      handleClose: () =>
        setLoading((prev) => ({ ...prev, case_status: false })),
      getOptionLabel: (option) => option.nombre_completo_status_task,
      getValue: (filters, options) =>
        options.find(
          (opt) =>
            opt.status_name === filters.status_name &&
            opt.status === filters.status,
        ) || null,
    },
  ];

  // ---------- COLUMNAS DE LA TABLA ----------
  const columns = useMemo(() => {
    const commonColumns = [
      {
        Header: `LISTA DE EXPEDIENTES`,
        columns: [
          {
            Header: "Expediente",
            accessor: "id",
            minWidth: 60,
            Cell: ({ value }) => (
              <RenderCell
                value={formatToTenDigits(value)}
                defaultValue=""
                link={true}
                dateFlag={false}
                icon={ArrowForwardIos}
                id={value}
                view="expedientes"
                color="success"
                iconPosition="end"
              />
            ),
          },
          {
            Header: "Vencimientos",
            accessor: "expiration",
            minWidth: 100,
            Cell: ({ value }) => (
              <RenderCell
                value={value ? "SI" : value == 0 ? "NO" : "Sin asignar"}
                view="expedientes"
              />
            ),
          },
          {
            Header: "Plazo de fin de tarea (automático)",
            accessor: "last_task.date_end",
            minWidth: 200,
            Cell: ({ row }) => <RenderVencimiento {...row.original} />,
          },
          {
            Header: "Fecha de juicio",
            accessor: "trial_date_time",
            Cell: ({ value }) => (
              <RenderTrialDate dates={value} flagTrial={true} />
            ),
          },
          {
            Header: "Fecha entrada",
            accessor: "date_in",
            minWidth: 120,
            Cell: ({ value }) => (
              <RenderCell value={value} dateFlag={true} view="expedientes" />
            ),
          },
          {
            Header: "Abogado",
            accessor: "full_lawyer_name",
            minWidth: 150,
            Cell: ({ value }) => (
              <RenderCell value={value} view="expedientes" />
            ),
          },
          {
            Header: "Tipo de proceso",
            accessor: "case_type_name",
            minWidth: 200,
            Cell: ({ value }) => (
              <RenderCell value={value} view="expedientes" />
            ),
          },
          {
            Header: "Cliente",
            accessor: "full_client_name",
            minWidth: 150,

            Cell: ({ value }) => (
              <RenderCell value={value} view="expedientes" />
            ),
          },
          {
            Header: "Provincia",
            accessor: "case_province",
            minWidth: 100,
            Cell: ({ value }) => (
              <RenderCell value={value} view="expedientes" />
            ),
          },
          // {
          //   Header: "Fecha de Juicio",
          //   accessor: "case_province",
          //   Cell: ({ value }) => (
          //     <RenderCell value={value} view="expedientes" />
          //   ),
          // },
          {
            Header: "Apud acta",
            accessor: "apud_acta",
            minWidth: 100,
            Cell: ({ value }) => (
              <RenderCell
                value={value ? "SI" : value == 0 ? "NO" : "Sin asignar"}
                view="expedientes"
              />
            ),
          },
          {
            Header: "Peritaje",
            accessor: "peritaje",
            minWidth: 100,
            Cell: ({ value }) => (
              <RenderCell
                value={value ? "SI" : value == 0 ? "NO" : "Sin asignar"}
                view="expedientes"
              />
            ),
          },

          // {
          //   Header: "Actualización",
          //   accessor: "last_update",
          //   minWidth: 120,
          //   Cell: ({ value }) => (
          //     <RenderCell value={value} dateFlag={true} view="expedientes" />
          //   ),
          // },

          {
            Header: "Estado",
            accessor: "full_case_status_name",
            minWidth: 150,
            Cell: ({ value }) => (
              <RenderCell value={value} view="expedientes" />
            ),
          },

          {
            Header: "Acciones",
            accessor: "case_id",
            Cell: ({ row }) =>
              renderActions(
                row.original.case_id,
                row.original.clients_relation,
                row.original,
              ),
          },
        ],
      },
    ];

    if (flagToShow) {
      commonColumns[0].columns.splice(5, 0, {
        Header: "Asociación",
        accessor: "case_asociation_name",
        minWidth: 190,
        Cell: ({ value }) => renderCellWithDefault(value),
      });
      commonColumns[0].columns.splice(12, 0, {
        Header: "Empresa",
        minWidth: 100,
        accessor: "company_name",
        Cell: ({ value }) => renderCellWithDefault(value),
      });
    }

    return commonColumns;
  }, [flagToShow]);

  // ---------- HOOKS ----------

  useEffect(() => {
    if (!hasPermission) {
      return;
    }

    getDataExpedientes();
  }, [
    pagination,
    search,
    clientCase,
    userCase,
    transferClient,
    caseCreated,
    clientCreated,
    currentClientTransfer,
    hasPermission,
  ]);

  useEffect(() => {
    if (data?.pageCount && pagination.pagePressed > data.pageCount) {
      // Solo actualiza si el valor va a cambiar realmente
      if (pagination.pagePressed !== 1) {
        setPagination((prev) => ({ ...prev, pagePressed: 1 }));
      }
    }
  }, [data?.pageCount]);

  useEffect(() => {
    setFilters((prevFilters) => ({ ...prevFilters, caseFilter: queryCase }));
  }, [queryCase]);

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      clientFilterName: queryClientName,
    }));
  }, [queryClientName]);

  useEffect(() => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      clientFilterSurname: queryClientSurname,
    }));
  }, [queryClientSurname]);

  const content = (
    <div className="mainContainer">
      <div className="subMainContainer">
        {/* FILTROS */}
        {flagToShow && can("cases", "view") && (
          <Grid container className="filtersContainer">
            <Grid item xs={4} md={1.5} textAlign="left" sx={{ padding: "5px" }}>
              <TextField
                onChange={(e) => setQueryCase(e.target.value)}
                label="Nº  Expediente"
                variant="outlined"
                size="small"
                autoComplete="new-password"
              />
            </Grid>
            <Grid item xs={4} md={1.5} textAlign="left" sx={{ padding: "5px" }}>
              <TextField
                onChange={(e) => setQueryClientName(e.target.value)}
                label="Nombre cliente"
                variant="outlined"
                size="small"
                autoComplete="new-password"
                value={queryClientName ? queryClientName : ""}
              />
            </Grid>
            <Grid item xs={4} md={1.5} textAlign="left" sx={{ padding: "5px" }}>
              <TextField
                onChange={(e) => setQueryClientSurname(e.target.value)}
                label="Apellido Cliente"
                variant="outlined"
                size="small"
                autoComplete="new-password"
                value={queryClientSurname}
              />
            </Grid>
            {autocompleteConfigs.map((config, index) => (
              <Grid
                item
                xs={4}
                md={config.key == "case_status" ? 3 : 1.5}
                textAlign="left"
                sx={{
                  padding: "5px",
                  display: "flex",
                  width: "100%",
                }}
                key={index}>
                {config.helperText && (
                  <Tooltip
                    title="Debes seleccionar una empresa para ver"
                    placement="right"
                    color="info">
                    <IconButton>
                      <Info />
                    </IconButton>
                  </Tooltip>
                )}
                <Autocomplete
                  size="small"
                  className="noBorderRadius"
                  value={config.getValue(filters, config.options)}
                  onChange={(event, value) => config.setFilter(value)}
                  open={config.loading}
                  onOpen={config.handleOpen}
                  sx={{ width: "100%" }}
                  onClose={config.handleClose}
                  getOptionLabel={config.getOptionLabel}
                  options={config.options}
                  loading={config.loading}
                  disabled={config.disabled}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={config.label}
                      InputProps={{
                        ...params.InputProps,
                        autoComplete: "new-password",
                        endAdornment: (
                          <Fragment>
                            {config.loading && (
                              <CircularProgress color="inherit" size={20} />
                            )}
                            {params.InputProps.endAdornment}
                          </Fragment>
                        ),
                      }}
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password",
                      }}
                    />
                  )}
                />
              </Grid>
            ))}
            {/* Fechas */}
            <Grid
              item
              xs={12}
              md={4.5}
              textAlign="left"
              sx={{ padding: "5px" }}>
              <LocalizationProvider
                dateAdapter={AdapterDayjs}
                adapterLocale="es">
                <DesktopDatePicker
                  renderInput={(props) => (
                    <TextField
                      className="rangeFilterDateLeft"
                      style={{ width: "50%", border: "0px" }}
                    />
                  )}
                  label="Fecha juicio desde"
                  value={dateEndFrom}
                  onChange={setDateEndFrom}
                  sx={{
                    width: "50%",
                    "& fieldset": {
                      borderRight: "none",
                      borderTopRightRadius: "0px",
                      borderBottomRightRadius: "0px",
                    },
                  }}
                />
                <DesktopDatePicker
                  renderInput={(props) => (
                    <TextField
                      className="rangeFilterDateRight"
                      style={{ width: "50%" }}
                    />
                  )}
                  label="Fecha juicio hasta"
                  value={dateEndTo}
                  onChange={setDateEndTo}
                  sx={{
                    width: "50%",
                    "& fieldset": {
                      borderLeft: "none",
                      borderTopLeftRadius: "0px",
                      borderBottomLeftRadius: "0px",
                    },
                  }}
                />
              </LocalizationProvider>
              <br />
            </Grid>
            {/* Botones */}
            <Grid
              item
              xs={12}
              md={12}
              textAlign="center"
              mt={1}
              sx={{
                display: "inline-flex",
                gap: "5px",
                justifyContent: "center",
              }}>
              <CustomButtonPlusIcon
                icon={Search}
                text={"BUSCAR"}
                handleFunction={() => setSearch(!search)}
                position={"start"}
                variant={"outlined"}
                color={"info"}
              />
              <CustomButtonPlusIcon
                icon={CleaningServices}
                text={"LIMPIAR FILTROS"}
                handleFunction={handleFilterStates}
                position={"start"}
                variant={"outlined"}
                color={"error"}
              />
            </Grid>
          </Grid>
        )}

        {flag && hasPermission && (
          <LoadingPage isLoading={flag} heightProp={"60vh"} />
        )}

        {/* TABLA */}
        {!flag && can("cases", "view") && (
          <Fade timeout={600} in={data?.cases?.length > 0 || dataNoResults}>
            <div>
              <Table
                icon={CreateNewFolder}
                columns={columns}
                data={data.cases}
                view={"expediente"}
                viewTitle={"expedientes"}
                totalPagesNumber={data.totalPagesNumber}
                flagToShow={flagToShow}
                viewPermission={"cases"}
              />
            </div>
          </Fade>
        )}

        <div
          className="tablePaginateContainer"
          style={{ marginBottom: "20px" }}>
          {data?.cases?.length > 0 && (
            <div className="paginatorLeftText">
              Mostrando{" "}
              {pagination.objPerPage * (pagination.pagePressed - 1) + 1} a{" "}
              {Math.min(
                pagination.objPerPage * pagination.pagePressed,
                data.totalPagesNumber,
              )}{" "}
              de {data.totalPagesNumber} resultados
            </div>
          )}
          {data.totalPagesNumber > 10 && (
            <ReactPaginate
              breakLabel="..."
              nextLabel={<ChevronRight size={18} />}
              previousLabel={<ChevronLeft size={18} />}
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={data.pageCount}
              containerClassName="pagination"
              activeClassName="active"
              pageClassName="page-item"
              nextClassName="page-item"
              previousClassName="page-item"
              disabledClassName="disabled"
              forcePage={pagination.pagePressed - 1}
            />
          )}
        </div>
      </div>
    </div>
  );

  // ---------- RENDERIZADO ----------
  return (
    <div className="fatherContainer">
      {flagToShow && <CommonSubHeader title="Expedientes" />}
      {!hasPermission && <Unauthorized />}
      {hasPermission && content}
    </div>
  );
};

export default Expedientes;
